import React from 'react'

/**
 * Types and Interface
 */
import {
  PostsState,
  HttpResponse,
  PostInterface,
  DefaultComponentProps,
}
from '@interface/common'

/**
 * Helpers
 */
import {pure} from '@react/store'
import string from '@helpers/string'
import {
  http,
  datetime,
}
from '@helpers/common'

/**
 * Components
 */
import Checkbox from '@components/checkbox'
import TableBottom from '@components/table/bottom'


/**
 * Images
 */
import './posts.scss'
import Spinner from '@assets/images/spinner.gif'



/**
 * Posts Screen
 */
export default pure(({user, store, modal}: DefaultComponentProps) => {
  const state = store.useLocalState({
    post: {},
    posts: [],
    selected: [],
    start: 0,
    limit: 20,
    type: null,
    error: false,
    review: false,
    block: false,
    status: null,
    approve: false,
    loading: true,
    fetching: true,
    moderator: null,
  })
  const updated = store.get('updated')

  /**
   * Get users
   */
  React.useEffect(() => {
    posts()
  }, [])


  /**
   * Update posts
   */
  React.useEffect(() => {

    if(updated) {
      state.set(({posts}: PostsState) => {
        if(updated.action === 'block') {
          posts = posts?.map((item: PostInterface) => {
            item = {...item}
            if(item.pid === updated.post.pid) {
              item.status = 'blocked'
            }
            return item
          })
        }
        if(updated.action === 'approve') {
          posts = posts?.filter((v: PostInterface) => v.pid !== updated.post.pid && v)
        }
        return {posts}
      })
    }
  }, [store])


  
  /**
   * Is checked?
   */
  function isChecked() {
    if(state.selected.length === 0) {
      return false
    }
    return state.selected.length === state.posts.length ? true : false
  }


  /**
   * Get posts
   * @param {string} type
   */
  function posts(type = null) {
    /**
     * Send request
     */
    http.get(`/posts`, {
      query: {
        status: 'public',
        user: {
          uid: user.root?.uid,
          role: user.organization?.role,
        },
        type,
        published: true,
        limit: state.limit,
        start: state.start,
      },
    })
    .then(({result}: HttpResponse) => {
      if(result) {
        state.set({posts: result, error: false, fetching: false})
      }
      else {
        state.set({posts: [], fetching: false})
      }
    })
    .catch((e: any) => {
      console.log(e)
    })
    state.set({fetching: true})
  }


  return (
    <div className="inner">
      <header>
        <div className="left">
          <h3 className="margin-0">Published</h3>
        </div>
        <div className="right filter">
          <span className="select">
            <label>Type</label>
            <select onChange={(e) => posts(e.target.value as never)}>
              <option value="">All</option>
              <option value="text">Text</option>
              <option value="share">Share</option>
              <option value="link">Link</option>
              <option value="media">Media</option>
            </select>
          </span>
          <span
            className="button-3"
            onClick={() => {
              modal.open({name: 'createPost', data: {}})
            }}>
            <span className="icon-plus"></span>
            <span className="text">Create Post</span>
          </span>
        </div>
      </header>
      <div className="table">
        <table>
          <thead>
            <tr>
              <th>
                <Checkbox
                  space={30}
                  onClick={(checked: boolean) => {
                    state.set({
                      selected: state.posts.reduce(
                        (items: [], item: any) => {
                          if(checked) {
                            items.push(item.pid as never)
                          }
                          else {
                            return items.filter((v: string) => v !== item.pid)
                          }
                          return items
                        },
                      [])
                    })
                  }}
                  checked={isChecked()}
                />
              </th>
              <th>Context</th>
              <th>Type</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {state.fetching ? (
              <tr>
                <td colSpan={5} style={{textAlign: 'center'}}>
                  <img alt={'Spinner'} src={Spinner} style={{width: 32, padding: 20}}/>
                </td>
              </tr>
            ):(
              <>
                {state.posts.length > 0 ? (
                  <>
                    {state.posts.map((item: PostInterface, key: number) => {
                      const date = datetime(item.created)

                      return (
                        <tr key={key}>
                          <td style={{width: 20}}>
                            <Checkbox
                              space={30}
                              onClick={(checked: boolean) => {
                                state.set(({selected}: any) => {
                                  if(checked) {
                                    selected.push(item.pid)
                                  }
                                  else {
                                    selected = selected.filter((v: string) => v !== item.pid)
                                  }
                                  return {selected}
                                })
                                
                              }}
                              checked={state.selected.includes(item.pid)}
                            />  
                          </td>
                          <td style={{maxWidth: 300}}>
                            {item.text ? string.ellipsis(item.text, 15) : (
                              <span style={{fontStyle: 'italic', color: '#bbb'}}>n/a</span>
                            )}
                          </td>
                          <td>{string.toUCFirst(item.type)}</td>
                          <td>{string.toUCFirst(item.status)}</td>
                          <td style={{width: 250}}>{date.getDate()}</td>
                          <td style={{width: 100}}>
                            <span
                              className="button-1"
                              onClick={() => {
                                modal.open({name: 'view', data: item})
                              }}>
                              View
                            </span>
                          </td>
                        </tr>
                      )
                    })}
                  </>
                ):(
                  <tr>
                    <td colSpan={5} style={{textAlign: 'center'}}>
                      <span>No Results</span>
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>
      <TableBottom
        entries={{
          onChange(e) {}
        }}
        pagination={{
          limit: state.limit,
          total: state.total,
          onClick(selected) {
            
          },
          onPrev() {
            
          },
          onNext() {
            
          },
        }}
      />
    </div>
  )
})